import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { MdContentCopy } from 'react-icons/md';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { TooltipReactTooltip } from 'components/Tooltip';
import { useTranslation } from 'react-i18next';
import { showOrHideString } from 'helpers/string';
import NewDesign from '..';
import { notifySuccess } from 'helpers/handleNotification';
import { copyToClipboard } from 'helpers';

const propTypes = {
  className: PropTypes.string,
  style: PropTypes.instanceOf(React.CSSProperties),
  enableCopy: PropTypes.bool,
  enableShow: PropTypes.bool,
  defaultShow: PropTypes.bool,
  onClickCopy: PropTypes.func,
  onClickShow: PropTypes.func,

  text: PropTypes.string,
  textHided: PropTypes.string,
};

const BoxWithShowHide = ({
  className = '',
  style = {},
  enableCopy = false,
  enableShow = false,
  defaultShow = false,
  onClickCopy = () => {},
  onClickShow = () => {},

  text = '',
  textHided = '',
}) => {
  //! State
  const { t } = useTranslation();
  const [show, setShow] = useState(defaultShow);

  //! Function
  const toggleShow = () => {
    setShow(!show);
  };

  const handleClickShow = () => {
    toggleShow();
    onClickShow && onClickShow(!show);
  };

  const onCopy = useCallback(() => {
    onClickCopy && onClickCopy(text);
    copyToClipboard(text);
    notifySuccess(t('notice:copy_clipboard_success'));
  }, [t, onClickCopy, text]);

  //! Render

  return (
    <div style={style} className={`new-design-copy bg-light ${className}`}>
      <NewDesign.Typography>
        {show ? text : textHided || showOrHideString(text)}
      </NewDesign.Typography>
      <div className='d-flex'>
        {enableShow && (
          <div className='p-1'>
            <TooltipReactTooltip
              idTarget='show_function'
              messageToolTip={show ? t('notice:hide') : t('notice:show')}
            >
              {show ? (
                <AiOutlineEyeInvisible onClick={handleClickShow} className='is-hover' />
              ) : (
                <AiOutlineEye onClick={handleClickShow} className='is-hover' />
              )}
            </TooltipReactTooltip>
          </div>
        )}

        {enableCopy && (
          <div className='p-1'>
            <TooltipReactTooltip idTarget='copy_function' messageToolTip={t('notice:copy')}>
              <MdContentCopy onClick={onCopy} className='is-hover' />
            </TooltipReactTooltip>
          </div>
        )}
      </div>
    </div>
  );
};

BoxWithShowHide.propTypes = propTypes;
export default React.memo(BoxWithShowHide);
